// https://app.growthbook.io/features/copy_feature_variables
export const BOGO_OFFER_VARIABLES_FLAG_NAME = 'copy_feature_variables'

// Feature variables keys
export const GREEN_TEXT_KEY = 'text_and_offer_name_green'
export const LINK_KEY = 'link'
export const ORANGE_TEXT_KEY = 'text_primary_orange'
export const TEXT_KEY = 'text'

// Feature variables
export const BANNER_OFFER_SLOGAN_BLUE_VARIABLE_NAME = 'banner_offer_slogan_blue'
export const PROMO_VARIABLE_NAMES = {
  modalOfferSlogan: 'modal_offer_slogan',
  discountModalPromoOverriden: {
    body: 'discount_modal_promo_overriden_body',
    cta: 'discount_modal_promo_overriden_cta',
  },
  quizStickyFooterCopy: 'quiz_sticky_footer_copy',
  giftPageTitle: 'gift_page_title',
  giftPageSubtitle: 'gift_page_subtitle',
}
export const OFFER_SLOGAN_YELLOW_VARIABLE_NAME = 'offer_slogan_yellow'
export const OFFER_TERMS_VARIABLE_NAME = 'offer_terms'
export const OFFER_TERMS_TEAL_VARIABLE_NAME = 'offer_terms_teal'
export const ORANGE_GREEN_VARIABLE_NAME = 'urgency_texts_orange_green'
export const URGENCY_TEXT_VARIABLE_NAME = 'urgency_text'
